import { render, staticRenderFns } from "./PetitionIndex.vue?vue&type=template&id=54f429c3&scoped=true&"
import script from "./PetitionIndex.vue?vue&type=script&lang=js&"
export * from "./PetitionIndex.vue?vue&type=script&lang=js&"
import style0 from "./PetitionIndex.vue?vue&type=style&index=0&id=54f429c3&prod&lang=css&"
import style1 from "./PetitionIndex.vue?vue&type=style&index=1&id=54f429c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f429c3",
  null
  
)

export default component.exports